import { Formik } from 'formik'
import React, { useContext, useEffect, useState } from 'react'
import { Stack } from '@mui/material'
import { renderButton, renderCancelButton, renderCheckField, renderSelectField, renderSelectFieldFilterable, renderTextAreaField, renderTextField } from '@/shared/FormUtils'
import { fetchAPI } from '@/utility/NetworkUtils'
import UserContext from '@/context/UserContext'
import Loading from '@/shared/Loading'
import InventoryChits from '../components/InventoryChits';
import ItemCost from '../components/ItemCost';
import { check } from 'prettier'
const ItemHoldFormRevised = ({
  item,
  onSubmit,
  onCancel,
  newItem = false,
  formikProps=null,
  item_hold = null,

}) => {
  const { user } = useContext(UserContext);
  const[ events, setEvents ] = useState(null);
  const [ inventoryCount, setInventoryCount ] = useState(null)
  const isEditing = !!item_hold
  useEffect(() => {
    fetchEvents();
  }, [])
  
  const fetchEvents = () => {
    fetchAPI(`/webapi/events/event_holds_modal`, (json) => {
      if (!json.error) {
        setEvents(json.events.filter(event => !event.archived_at))
      } else {
        console.log({
          errors: json.errors
        })
      }
    })
  }

  const checkDetailsNotFinalized = async (formikProps, change) => {
    const item_hold = {
      ...formikProps.values.item_hold,
      ...change
    }
    const isDisabled = !(item_hold.location && item_hold.shipping_address_id && item_hold.total_count)
    if(isDisabled) {
      formikProps.setFieldValue("item_hold.order_not_finalized", true)
      formikProps.setFieldValue("order_not_finalized_manually_checked", false)
    } else if(!(formikProps?.values?.order_not_finalized_manually_checked)) {
      formikProps.setFieldValue("order_not_finalized_manually_checked", true)
      formikProps.setFieldValue("item_hold.order_not_finalized", false)
    }
  }

  const getCurrentEvent = (formikProps) => {
    if(events == null) {
      return null
    }
    if(!formikProps.values.item_hold.event_id) {
      return null
    }
    const foundEvent = events.find(event => event.id === formikProps.values.item_hold.event_id)
    if(item_hold && !foundEvent){
      return item_hold?.event
    }
    return foundEvent
  }
  const submitForm = (values, formikProps) => {
    formikProps.setSubmitting(true)

    const url = isEditing ? `/events/${values.item_hold.event_id}/item_holds/${item_hold.id}` : `/events/${values.item_hold.event_id}/item_holds`
    fetchAPI(url, (json) => {
      formikProps.setSubmitting(false)
      if (!json.error) {
        if(onSubmit) {
          onSubmit()
        }

      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {
      method: isEditing ? "PATCH" : "POST",
      body: {
        item_hold: values.item_hold 
      }
    })
  }

  const getMaximumQuantity = () => {
    if(!inventoryCount) {
      return 0
    }
    if(item_hold) {
      let maxQuantity = inventoryCount.available + inventoryCount.expected_receiving + item_hold.total_count
      if(item_hold && item_hold.total_count > maxQuantity) {
        return item_hold.total_count
      }
      return maxQuantity
    }

    return inventoryCount.available + inventoryCount.expected_receiving
  }

  const isHoldLocked = () => {
    return item_hold && item_hold.locked
  }
  const renderForm = (formikProps) => {
    const event = getCurrentEvent(formikProps)
    if(!events) {
      return <Loading />
    }
    return (
      <Stack direction="column" spacing={2}>  

        {!isEditing && renderSelectFieldFilterable("Event", "item_hold[event_id]", events.sort((a,b)=>{
          try {
            const aDate = new Date(a.start_date);
            const bDate = new Date(b.start_date);
            if(aDate == bDate) {
              return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
            }
            return aDate - bDate
          } catch(e) {
            return 0
          }
        }).map(event => {return {label: event.name, value: event.id}}), {disabled: isHoldLocked(), required: true})}
        {formikProps.values.item_hold.event_id && !newItem && (
          <>
            <div className={isEditing ? "w-0 overflow-hidden m-0-important m-0 h-0" : ""}>
                <InventoryChits
                  item={item}
                  event={events.find(event => event.id === formikProps.values.item_hold.event_id)}
                  onLoad={(json)=> {
                    setInventoryCount(json)
                  }}
                />
            </div>
            {inventoryCount && (
              <div>
                <div className="w-1/2">
                  {renderTextField("Quantity", "item_hold[total_count]", {
                    disabled: isHoldLocked(),
                    required: true,
                    type: "number",

                    fieldProperties: {
                      inputProps:{ 
                        min: 0,
                        max: getMaximumQuantity(),
                        type: "number",
                        step: 1,
                        onBlur: (e) => {
                          formikProps.setFieldValue("item_hold[total_count]", Math.max(0,Math.min(parseInt(e.target.value), getMaximumQuantity())))
                        }
                      },
                      onChange: (e)=>{
                        const value = Math.max(0,Math.min(parseInt(e.target.value), getMaximumQuantity()))
                        formikProps.setFieldValue("item_hold[total_count]", 
                          value
                        )
                        checkDetailsNotFinalized(formikProps, {total_count: value})
                      },
                      type: "number",
                      step: 1
                    }
                  })}
                </div>
              </div>
            )}
          </>
        )}
        {
          formikProps.values.item_hold.event_id && (
            <>
              {renderSelectFieldFilterable(
                "Shipping Location",
                "item_hold[shipping_address_id]",
                generateAddressOptions(formikProps),
                {
                  disabled: isHoldLocked(),
                  required: true,
                  fieldProperties: {
                    renderOption: renderAddressOption,
                    getOptionLabel: (option) => {  return option.label}
                 },
                 onChange: (e) => {
                    checkDetailsNotFinalized(formikProps, {shipping_address_id: e})
                 }
                }
              
              )}
              <Stack direction="row" spacing={2}>
                {renderSelectFieldFilterable(
                  "Onsite Distribution Info",
                  "item_hold[location]",
                  (event?.unique_event_locations||[]).map(location => {return {label: location, value: location}}),
                  {
                    disabled: isHoldLocked(),
                    required: true,
                    fieldProperties: {
                      getOptionLabel: (option) => { return option.label}
                    },
                    onChange: (e) => {
                      checkDetailsNotFinalized(formikProps, {location: e})
                    }
                  }
                
                )}
                {renderSelectFieldFilterable(
                  "Onsite Recipient",
                  "item_hold[recipient]",
                  (event.unique_event_recipients||[]).map(location => {return {label: location, value: location}}),
                  {
                    disabled: isHoldLocked(),
                    required: false,
                    fieldProperties: {
                      getOptionLabel: (option) => { return option.label}
                    }
                  }
                
                )}
              </Stack>
              {renderTextAreaField("Notes", "item_hold[notes]", {
                disabled: isHoldLocked(),
              })}
              <Stack direction="row" spacing={2}  >
                <div className="w-1/2">
                {renderCheckField("Shipping directly to site", "item_hold[direct_to_site]", ['mb-0'], {
                  disabled: isHoldLocked(),
                })}
                </div>
                <div className="w-1/2">
                {renderCheckField("Not Returning", "item_hold[not_returning]", ['mb-0'], {
                  disabled: isHoldLocked(),
                })}
                </div>
              </Stack>
              <Stack direction="row" spacing={2} style={{marginTop: "0px"}}>
                <div className="w-1/2">
                {renderCheckField("Details Not Finalized", "item_hold[order_not_finalized]", ['mb-0'], {
                  disabled: isHoldLocked() || !(formikProps.values.item_hold.location && formikProps.values.item_hold.shipping_address_id && formikProps.values.item_hold.total_count),
                  onChange: (e) => {
                    formikProps.setFieldValue("item_hold[order_not_finalized]", e.target.checked)
                    formikProps.setFieldValue("order_not_finalized_manually_checked", true)
                  },
                  onBlur: (e) => {
                    formikProps.setFieldValue("order_not_finalized_manually_checked", true)
                  }
                })}
                </div>
                <div className="w-1/2">
                {renderCheckField("Dispose after event", "item_hold[dispose_after_event]", ['mb-0'], {
                  disabled: isHoldLocked(),
                })}
                </div>
              </Stack>
            </>
          )
        }
      </Stack>
    )
  }

  const renderButtons = (formikProps) => {
    isMoreThanMaxQuanity = isEditing ? false : (formikProps.values.item_hold.total_count > getMaximumQuantity())
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        {renderCancelButton("Cancel", onCancel)}
        {renderButton(isEditing ? "Save" : "Add To Event", formikProps.handleSubmit, {color:"burgandy", disabled: isHoldLocked() || formikProps.isSubmitting || !formikProps.values.item_hold.total_count || isMoreThanMaxQuanity})}
      </Stack>
    )
  }

  const renderAddressOption = (props, data) =>{
    return (
      <div {...props} className="hover:bg-[#e6e6e6]" style={{ alignItems: 'center', padding: '8px 12px' }}>
        <div className="block">
          <b>{data.label}</b>
        </div>
        <div  className="block">
          {data.address?.address_line_1} 
          <br/>
          {data.address?.address_line_2}
        </div>
        <div className="block">
          {[data.address?.city, data.address?.state_province, data.address?.postal_code].filter(x=>x).join(", ")}
        </div>
        <div className="block">
          {data.address?.country}
        </div>
      </div>
    )
  }
    

  const generateAddressOptions = (formikProps) => {
    const event = getCurrentEvent(formikProps)
    if(event && event.shipping_addresses) {
      return event.shipping_addresses.map(address =>
        {return {label: address.venue_name, value: address.id, address: address}}
      );
    }
    return []
  }


  if(formikProps) {
    return (
      <div>
        {renderForm(formikProps)}
      </div>
    )
  }

  return (
    <Formik
      initialValues={{
        item_hold: {
          event_id: item_hold ? item_hold.event_id : null,
          item_id: item_hold ? item_hold.item_id : item.id,
          total_count: item_hold ? item_hold.total_count : 0,
          order_not_finalized:  item_hold ? item_hold.order_not_finalized : true,
          not_returning: item_hold ? item_hold.not_returning : false,
          direct_to_site: item_hold ? item_hold.direct_to_site : false,
          shipping_address_id: item_hold ? item_hold.shipping_address_id : null,
          location: item_hold ? item_hold.location : null,
          recipient: item_hold ? item_hold.recipient : null,
          notes: item_hold ? item_hold.notes : "",
          dispose_after_event: item_hold ? item_hold.dispose_after_event : false
        }
      }}
      onSubmit={submitForm}
    >
      {(formikProps) => (
        <Stack direction="column" spacing={2}>
          <div>
            <div class="text-emerald-900 text-4xl font-medium font-['Roboto'] pb-4 font-weight-[400]">
              {item.name}
            </div>
            <ItemCost item={item} />
          </div>
          {renderForm(formikProps)}
          {!newItem ? renderButtons(formikProps) : null}
        </Stack>
      )}
    </Formik>
  )
}

export default ItemHoldFormRevised